import { fromJS } from 'immutable';

import { INIT, INIT_FAILED } from './types';

export const initialState = fromJS({
  error: null,
});

export default (state = initialState, action: { type: string; error?: Error }) => {
  switch (action.type) {
    case INIT:
      return state.merge({ error: null });

    case INIT_FAILED:
      return state.merge({ loading: false, error: action.error });

    default:
      return state;
  }
};
